import React from 'react';

import { Explorer } from '../Explorer';
import { Summary } from './Summary';

export const NotOwnedSandboxInfo = () => (
  <>
    <Summary />
    <Explorer />
  </>
);
